module.exports = __webpack_public_path__ + "static/media/brick.816fec76.svg";